export default __webpack_public_path__ + "static/media/mometu_logo.a7f08273.png";